import Vue from 'vue';
import commonScripts from './common';
import stickyHeader from './partials/sticky_header';
import emailValidation from './partials/helpers/email_validation';
import getOffset from './partials/helpers/get_offset';

commonScripts();
stickyHeader(250);

new Vue({
	el: '#contactForm',
	data: {
		topic: '',
		message: '',
		name: '',
		email: '',
		sendCopy: false,
		confirmation: false,
		validation: {
			topic: '',
			message: '',
			name: '',
			email: '',
			confirmation: '',
		},
		isSending: false,
		sendSuccess: false,
		sendFailure: false
	},
	delimiters: ['${', '}'],
	methods: {
		expandLabel(e) {
			const link = e.target;
			const checkbox = link.closest('.checkbox');
			const checkboxClass = checkbox.classList;
			const collapsed =  checkboxClass.toggle('checkbox--collapsed');

			if (collapsed) {
				link.textContent = 'Rozwiń';
			} else {
				link.textContent = 'Zwiń';
			}
		},

		textLengthValidation(e, length, key) {
			const value = e.target.value;

			(value.length > length) ? this.validation[key] = `Wiadomość powinna mieć mniej niż ${length} znaków` : this.validation[key] = '';
		},

		emailValidation(e) {
			const email = e.target.value;

			(!emailValidation(email)) ? this.validation['email'] = 'Nieprawidłowy e-mail' : this.validation['email'] = '';
		},

		checkboxValidation(e, key) {
			const value = e.target.checked;

			(!value) ? this.validation[key] = 'To pole jest wymagane': this.validation[key] = '';
		},

		clearFields() {
			this.topic = '';
			this.message = '';
			this.name = '';
			this.email = '';
			this.sendCopy = false;
			this.confirmation = false;
		},

		submit(e) {
			const btn = e.target;
			const form = btn.closest('form');
			const fields = form.querySelectorAll('[name]');

			(!this.topic) ? this.validation.topic = 'To pole nie może być puste' : false;
			(!this.message) ? this.validation.message = 'To pole nie może być puste' : false;
			(!this.name) ? this.validation.name = 'To pole nie może być puste' : false;
			(!this.email) ? this.validation.email = 'To pole nie może być puste' : false;
			(!this.confirmation) ? this.validation.confirmation = 'To pole jest wymagane' : false;

			for (const v in this.validation) {
				if (this.validation[v]) {
					return;
				}
			}

			this.isSending = true;
			let data = new FormData();

			for (const field of fields) {
				data.append(field.name, field.value);
			}

			fetch(window.location.href, {
				method: 'post',
				body: data,
			}).then((response) => {
				if (response.ok) {
					return response.json();
				}
				throw new Error("Problem z formularzem, spróbuj ponownie.");
			}).then(json => {
				this.isSending = false;
				this.sendSuccess = true;
				this.sendFailure = false;

				console.log(json);

				this.clearFields();

				window.scroll({
					top: getOffset('#contactForm'),
					behavior: 'smooth',
				});
			}).catch(error => {
				this.isSending = false;
				this.sendSuccess = false;
				this.sendFailure = true;

				console.log(error);

				window.scroll({
					top: getOffset('#contactForm'),
					behavior: 'smooth',
				});
			});
		}
	}
});



// WEBPACK FOOTER //
// ./assets/js/contact.js